const getters = {
  roles: state => state.User && state.User.userInfo && [state.User.userInfo.userType], // 角色列表
  userInfo: state => state.User && state.User.userInfo // 用户信息
}
export default getters
